// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import RadioSelector from './RadioSelector'
import styled, { type StyledComponent } from 'styled-components'
import { blueLinkDashed } from '../AdEdit/controls'
import type { Node } from 'react'
import type { OptionType } from '../types'

const ItemText: StyledComponent<Object, any, any> = styled.div`
  ${blueLinkDashed()};
  cursor: pointer;
`

const StyledRadioSelector: any = ((styled(RadioSelector).attrs({
  itemClass: 'item-class',
  selectedItemClass: 'selected-item-class'
}): any)`
  & {
    .item-class {
      display: inline-block;
    }
    .selected-item-class {
      ${ItemText} {
        background-image: linear-gradient(to bottom, #1a89c1 0%, #2ab3d5 100%);
        box-shadow: inset rgba(0, 0, 0, 0.3) 0 1px 3px 0;
        border: none;
        color: #fff;
        padding: 10px;
        margin: 0;
        border-radius: 5px;
      }
    }
    ${ItemText} {
      padding-top: 10px;
    }
    .selected-item-class {
      ${ItemText} {
        padding-bottom: 10px;
      }
    }
`: any)

type Props = {|
  value: string,
  options: Array<OptionType>,
  onChange?: (string) => void,
  optionRenderer?: (option: OptionType) => Node,
  labelRenderer?: (option: OptionType) => Node
|}

export default class Switcher extends Component<Props> {
  render() {
    return (
      <StyledRadioSelector
        radioOptions={this.radioOptions()}
        value={this.props.value}
        onChange={(value) => this.valueChanged(value)}
      />
    )
  }

  radioOptions(): Array<{| value: any, renderer: Node |}> {
    return _.map(this.props.options, (option) => ({
      value: this.optionValue(option),
      renderer: this.renderOption(option)
    }))
  }

  renderOption(option: OptionType) {
    const { optionRenderer, labelRenderer } = this.props

    return optionRenderer ? (
      optionRenderer(option)
    ) : (
      <ItemText className="t-SwitcherItemText">
        {labelRenderer ? labelRenderer(option) : this.optionLabel(option)}
      </ItemText>
    )
  }

  optionValue(option: OptionType) {
    return option.id
  }

  optionLabel(option: OptionType) {
    return option.name
  }

  valueChanged(value: string) {
    this.props.onChange && this.props.onChange(value)
  }
}
